export var ETopic = /*#__PURE__*/function (ETopic) {
  ETopic["ComplaintFromOwnerProperty"] = "complaintFromOwnerProperty";
  ETopic["ComplaintFromOwnerPhoto"] = "complaintFromOwnerPhoto";
  ETopic["OfferComplaint"] = "offerComplaint";
  ETopic["Moderation"] = "moderation";
  ETopic["XmlUnloading"] = "xmlUnloading";
  ETopic["Money"] = "money";
  ETopic["Commercial"] = "commercial";
  ETopic["Another"] = "another";
  ETopic["Documents"] = "documents";
  ETopic["Login"] = "login";
  ETopic["Offers"] = "offers";
  ETopic["PrMedia"] = "prMedia";
  ETopic["Advertising"] = "advertising";
  ETopic["PartnerRewards"] = "partnerRewards";
  return ETopic;
}({});